import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step244100Meta extends BaseModel {
  /**
   * @var {?boolean}
   */
  isSpousePermanentResidentOfCountry;

  constructor(model = {}) {
    super();
    this.isSpousePermanentResidentOfCountry = model.isSpousePermanentResidentOfCountry ?? null;
  }
}
